import { useTranslation } from 'react-i18next';
import { TranslationsKeys } from '../../../locales/translations';
import { useMemo } from 'react';
import { CellFormatOptions, ColumnTable } from '@octano/global-ui';
import { Badge } from 'reactstrap';
import { getLessonStatus } from '../utils';
import {
  statusBackgroundColorMapLessonTeacher,
  TeacherAttendance,
} from '../types';

export const useColumns = () => {
  const { t } = useTranslation(TranslationsKeys.TEACHER_ATTENDANCE_LIST);

  const columns: ColumnTable<TeacherAttendance>[] = useMemo(() => {
    return [
      {
        headerText: t(`table.columns.responsible`),
        columnName: 'responsible',
        tdClassName: 'text-center',
        thClassName: 'text-center',
      },
      {
        headerText: t(`table.columns.school`),
        columnName: 'school',
        tdClassName: 'text-center',
        thClassName: 'text-center',
      },
      {
        headerText: t(`table.columns.course`),
        columnName: 'course',
        tdClassName: 'text-center',
        thClassName: 'text-center',
      },
      {
        headerText: t(`table.columns.section`),
        columnName: 'section',
        tdClassName: 'text-center',
        thClassName: 'text-center',
      },
      {
        headerText: t(`table.columns.date`),
        columnName: 'date',
        tdClassName: 'text-center',
        thClassName: 'text-center',
      },
      {
        headerText: t(`table.columns.initModule`),
        columnName: 'initModule',
        tdClassName: 'text-center',
        thClassName: 'text-center',
      },
      {
        headerText: t(`table.columns.endModule`),
        columnName: 'endModule',
        tdClassName: 'text-center',
        thClassName: 'text-center',
      },
      {
        headerText: t(`table.columns.status`),
        columnName: 'status',
        tdClassName: 'text-center',
        thClassName: 'text-center',
        cellFormat: (data: CellFormatOptions<TeacherAttendance>) => {
          return (
            <div className="d-flex justify-content-start" style={{ gap: 10 }}>
              <div
                style={{
                  borderRadius: 4,
                  width: 24,
                  height: 20,
                  backgroundColor:
                    data.row.status !== 'no-ejecutada' ? '#FFE6A1' : '#F2C0BD',
                }}
              />
              <span>{getLessonStatus(data.row.status)?.label}</span>
            </div>
          );
        },
      },
      {
        headerText: t(`table.columns.justification`),
        columnName: 'hasJustification',
        tdClassName: 'text-center',
        thClassName: 'text-center',
        cellFormat: (data: CellFormatOptions<TeacherAttendance>) => {
          return (
            <div
              style={{
                padding: '5px',
                borderRadius: 5,
                border: '1px solid var(--primary)',
                color: 'var(--primary)',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                backgroundColor: data.row.hasJustification ? '#FFE6A1' : '',
              }}
              className="text-capitalize"
            >
              JUSTIFICADO
            </div>
          );
        },
      },
      {
        headerText: t(`table.columns.justificationState`),
        columnName: 'justificationState',
        tdClassName: 'text-center',
        thClassName: 'text-center',
        cellFormat: (data: CellFormatOptions<TeacherAttendance>) => {
          return (
            <Badge
              className="fs-14 fw-400 py-2 px-3 text-dark"
              style={{
                backgroundColor:
                  statusBackgroundColorMapLessonTeacher[
                    data.row?.justificationStatus ?? 'pending'
                  ],
              }}
              pill
            >
              {t(`form.status.${data.row?.justificationStatus ?? 'pending'}`)}
            </Badge>
          );
        },
      },
    ];
  }, [t]);

  return columns;
};
